module.exports = __webpack_public_path__ + "img/1.f65b4b34.png";